export enum DateRangePreset {
  "THIS_WEEK",
  "LAST_WEEK",
  "TWO_WEEKS_AGO",
  "CUSTOM",
}
